import { render } from "./user.need.reply.vue?vue&type=template&id=18f3157a&scoped=true"
import script from "./user.need.reply.vue?vue&type=script&lang=js"
export * from "./user.need.reply.vue?vue&type=script&lang=js"

import "./user.need.reply.vue?vue&type=style&index=0&id=18f3157a&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f3157a"]])

export default __exports__